import { isShowingAllDealCategories } from "./dealCategoryParam";

export const countAppliedDealsFilters = ({
  timeOfDay = "",
  area = "",
  category = "",
  discountType = "",
  priceBand = "",
} = {}) => {
  let count = 0;
  if (String(timeOfDay || "").trim()) count += 1;
  if (String(area || "").trim()) count += 1;
  if (
    String(category || "").trim() &&
    !isShowingAllDealCategories(category)
  ) {
    count += 1;
  }
  if (String(discountType || "").trim()) count += 1;
  if (
    String(priceBand || "").trim() &&
    priceBand !== "any"
  ) {
    count += 1;
  }
  return count;
};
